import React, { useState } from 'react';
import './PaymentTest.css';
import logo from '../assets/logo.png';

const API = 'https://aayushrealproperties.in/nimaibackend/public/api';

const PaymentTest = () => {
    const [form, setForm]       = useState({ name: '', email: '', phone: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError]     = useState('');

    const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

    const handlePay = async (e) => {
        e.preventDefault();
        setError('');
        if (!form.name || !form.email || !form.phone) {
            setError('Please fill all fields.');
            return;
        }
        setLoading(true);
        try {
            const res  = await fetch(`${API}/test-payment-initiate`, {
                method:  'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body:    JSON.stringify(form),
            });
            const text = await res.text();
            const i    = text.search(/\{|\[/);
            const json = JSON.parse(i !== -1 ? text.substring(i) : text);

            if (!json.status || !json.access_key) {
                setError(json.message || 'Failed to initiate payment. Check Easebuzz credentials.');
                setLoading(false);
                return;
            }

            // Redirect to Easebuzz live checkout
            window.location.href = `https://pay.easebuzz.in/pay/${json.access_key}`;

        } catch (err) {
            setError('Network error: ' + err.message);
            setLoading(false);
        }
    };

    return (
        <div className="pt-page">
            <div className="pt-blob pt-blob--1" />
            <div className="pt-blob pt-blob--2" />

            <div className="pt-card">
                {/* Logo */}
                <div className="pt-logo">
                    <img src={logo} alt="Nimai Solutions" />
                    <span>Nimai Solutions</span>
                </div>

                {/* Test badge */}
                <div className="pt-test-badge">🧪 LIVE PAYMENT TEST</div>

                {/* Amount */}
                <div className="pt-amount-wrap">
                    <div className="pt-amount">
                        <span className="pt-currency">₹</span>
                        <span className="pt-num">1</span>
                        <span className="pt-paisa">.00</span>
                    </div>
                    <p className="pt-amount-note">Real ₹1 will be charged to your account</p>
                </div>

                {/* Form */}
                <form onSubmit={handlePay} className="pt-form">
                    <div className="pt-field">
                        <label>Full Name</label>
                        <input
                            name="name"
                            type="text"
                            placeholder="Enter your name"
                            value={form.name}
                            onChange={handleChange}
                            disabled={loading}
                        />
                    </div>
                    <div className="pt-field">
                        <label>Email Address</label>
                        <input
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            value={form.email}
                            onChange={handleChange}
                            disabled={loading}
                        />
                    </div>
                    <div className="pt-field">
                        <label>Phone Number</label>
                        <input
                            name="phone"
                            type="tel"
                            placeholder="10-digit mobile number"
                            value={form.phone}
                            onChange={handleChange}
                            maxLength={10}
                            disabled={loading}
                        />
                    </div>

                    {error && <div className="pt-error">⚠️ {error}</div>}

                    <button type="submit" className="pt-pay-btn" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="pt-spinner" />
                                Redirecting to Easebuzz…
                            </>
                        ) : (
                            <>
                                🔒 Pay ₹1 via Easebuzz
                            </>
                        )}
                    </button>
                </form>

                {/* Info */}
                <div className="pt-info">
                    <div className="pt-info-row">
                        <span>💳</span><span>UPI, Cards, Net Banking, Wallets accepted</span>
                    </div>
                    <div className="pt-info-row">
                        <span>🔐</span><span>256-bit SSL encrypted — powered by Easebuzz</span>
                    </div>
                    <div className="pt-info-row">
                        <span>↩️</span><span>You will be redirected back after payment</span>
                    </div>
                </div>

                <p className="pt-disclaimer">
                    This is a live payment test page. ₹1 will be charged using Easebuzz production gateway.
                    Delete this page before going live.
                </p>
            </div>
        </div>
    );
};

export default PaymentTest;
